export default {
    PriceA: "PriceA",
    PriceB: "PriceB",
}